import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import Button from '../../common/Button'
import LoadingButton from '../../common/LoadingButton'
import DestroyHighlight from '../queries/DestroyHighlight'

const Container = styled.div`
  border: 1px solid #b4b5b6;
  background: white;
  border-radius: 5px;
  padding: 30px;
  color: #666666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 216px;
  width: 380px;
`
const Title = styled.h3`
height: 22px;
width: 295px;
color: #616165;
font-family: "Open Sans";
font-size: 16px;
letter-spacing: 0.41px;
line-height: 22px;
text-align: center;
margin-bottom: 50px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  width: 84px;
  color: #56565A;
  margin-right: 25px;
`
const Delete = styled(LoadingButton)`
  margin-left: 25px;
  width: 84px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 19px;
  text-align: center;
  background-color: #BC3C4B;
`

class DeleteTopicConfirmationModal extends Component {
  constructor() {
    super()
    this.state = {
      isLoading: false
    }
  }

  onDeleteClick = async () => {
    const { highlightId, destroyHighlight, toggleModal, updateTopicList , onCloseClick } = this.props

    if (highlightId !== null){
      try {
        await destroyHighlight({
          variables: {
            input: {
              highlightId
            }
          }
        })
        updateTopicList()
        toggleModal()
      } catch (err) {
        console.error(err)
      }
    } else {
      onCloseClick()
      toggleModal()
    }
  }

  render() {
    const { toggleModal } = this.props
    const { isLoading } = this.state

    return (
      <Container>
        <Title>Are you sure you want to delete this?</Title>
        <ButtonContainer>
          <Cancel onClick={toggleModal}>
            Cancel
          </Cancel>
          <Delete
            loading={isLoading}
            onClick={this.onDeleteClick}>
            Delete
          </Delete>
        </ButtonContainer>
      </Container>
    )
  }
}
export { DeleteTopicConfirmationModal }

export default graphql(DestroyHighlight, {
  name: 'destroyHighlight'
})(DeleteTopicConfirmationModal)
